<template>
  <select
    :id="id"
    :name="name"
    class="form-control form-control--select"
    :class="className"
    :tabindex="tabindex"
    @change="onChangeItem"
  >
    <template v-if="hasPlaceholder">
      <option value>{{ placeholder }}</option>
    </template>

    <option
      v-for="(item, index) in items"
      :key="index"
      :value="item.id"
      :selected="isSelectedItem(item.id)"
    >{{ item.id }}</option>
  </select>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    className: {
      type: String,
      default: ""
    },
    tabindex: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      items: []
    };
  },
  created : function () {
    this.getItems();
  },
  computed: {
    hasPlaceholder: function() {
      return this.placeholder !== "";
    }
  },
  mounted: function() {
    if (this.value != "") {
      this.onSelectItem(this.value);
    }
  },
  methods: {
    getItems: function() {
      let kolonne = [];

      let promise = this.$api
          .clearParams()
          .get("kolonne");

      promise
        .then(
          response => {
            response.data.data.forEach(function(item) {
              kolonne.push({
                id: item.number
              });
            });
          }
        ).catch(
          error => {
            window.app.$helpers.logger(error);
          }
        );

      this.items = kolonne;
    },
    onSelectItem: function(id) {
      this.$emit("input", id);
      this.$emit("change", this.getItemById(id));
    },
    onChangeItem: function(event) {
      this.onSelectItem(event.currentTarget.value);
    },
    isSelectedItem: function(id) {
      return this.value === id;
    },
    getItemById: function(id) {
      let output = null;

      this.items.forEach(
        function(item) {
          if (item.id == id) {
            output = item;
          }
        }.bind(this)
      );

      return output;
    }
  }
};
</script>